import * as React from 'react';
import Breadcrumbs, { PropBreadcrumbItem } from '@able/react/dist/Breadcrumbs';
import { secureRouteBuilder } from '@applications/secure-route';
import Route from '@applications/order-tracker/route-constants';
import {
  OrderDetailsBreadcrumbLabels,
} from '../../../../config/order-tracker-new-common/constants';
import { Application } from '@applications/order-tracker';
import {
  Components,
  Links,
} from '@telstra-connect/order-tracker/activity-tracking';
import '../../style.less';

const iconDevelopmentURL = require('../../../../../../images/able-sprites.svg');

const trackOmnitureForDashboardFromOrderDetails = () => {
  Application.tracker.trackLink(
    Links.orderDetails.DashboardBreadcrumb,
    Components.orderDetailsPage
  );
};
const trackOmnitureForTrackingFromOrderDetails = () => {
  Application.tracker.trackLink(
    Links.orderDetails.TrackingBreadcrumb,
    Components.orderDetailsPage
  );
};

const OrderDetailsBreadcrumbs = () => {
  const orderDetailsBreadcrumbItems: PropBreadcrumbItem[] = [
    {
      label: OrderDetailsBreadcrumbLabels.Home,
      to: '/',
      events: { onClick: () => trackOmnitureForDashboardFromOrderDetails() },
    },
    {
      label: OrderDetailsBreadcrumbLabels.Tracking,
      to: secureRouteBuilder(Route.TrackingOrdersTab()),
      events: { onClick: () => trackOmnitureForTrackingFromOrderDetails() },
    },
  ];

  return (
    <Breadcrumbs
      developmentUrl={iconDevelopmentURL}
      breadcrumbs={orderDetailsBreadcrumbItems}
      id="order-details-breadcrumbs"
    />
  );
};

export default OrderDetailsBreadcrumbs;
